export class ToolCategory {
  constructor(
    public hash?: string,
    public name?: string
  ) { }

  clone() {
    return new ToolCategory (
      this.hash,
      this.name
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/tool-category.ts